'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = require('react-intl');

var _reactHoverintent = require('@liveauctioneers/react-hoverintent');

var _reactHoverintent2 = _interopRequireDefault(_reactHoverintent);

var _components = require('../../../components');

var _noop = require('../../../utils/noop');

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MegaNavLink = require('./MegaNavLink.scss');

var _MegaNavLink2 = _interopRequireDefault(_MegaNavLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MegaNavLink = function (_Component) {
    (0, _inherits3.default)(MegaNavLink, _Component);

    function MegaNavLink(props, context) {
        (0, _classCallCheck3.default)(this, MegaNavLink);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MegaNavLink.__proto__ || (0, _getPrototypeOf2.default)(MegaNavLink)).call(this, props, context));

        _this.state = {
            active: false
        };
        return _this;
    }

    (0, _createClass3.default)(MegaNavLink, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['active', 'link', 'mobile', 'msgId']) || (0, _propsComparer2.default)(this.state, nextState, ['active']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                active = _props.active,
                link = _props.link,
                mobile = _props.mobile,
                msgId = _props.msgId,
                openNav = _props.openNav,
                closeNav = _props.closeNav,
                tabletNavigation = _props.tabletNavigation;


            var isPhone = mobile && mobile !== 'tablet';
            var isTablet = mobile === 'tablet';
            return (0, _jsx3.default)(_reactHoverintent2.default, {
                onMouseOver: isTablet ? _noop2.default : openNav,
                onMouseOut: _noop2.default,
                sensitivity: 5,
                interval: 50,
                timeout: 50
            }, void 0, (0, _jsx3.default)('div', {
                className: _MegaNavLink2.default.navLink + ' ' + (active && !isPhone ? _MegaNavLink2.default.active : '')
            }, void 0, (0, _jsx3.default)(_components.Link, {
                onClick: !isTablet ? closeNav : tabletNavigation,
                route: true,
                to: isTablet ? '' : link,
                primaryWeak: true
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: msgId
            }))));
        }
    }]);
    return MegaNavLink;
}(_react.Component);

exports.default = MegaNavLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Navigation/MegaNavLink.js
// module id = qG7W
// module chunks = 57